(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('JobAssigneesActionsModalController', ['$scope', 'modalData', 'onSave', function ($scope, modalData, onSave) {

            var manageAssigneesMode = $scope.manageAssigneesMode = modalData.action;
            var selectedJobsIds = modalData.selectedJobsIds;
            var sharedAssignees = modalData.sharedAssignees;

            $scope.loadingData = true;
            $scope.numberOfSelectedJobs = selectedJobsIds.length;
            $scope.numberOfLocationsForSelectedJobs = modalData.locationsIdsForSelectedJobs.length;

            $scope.jobPluralState = $scope.numberOfSelectedJobs === 1 ? $filter('translate')('selected job in') : $filter('translate')('selected jobs in');
            $scope.locationPluralState = $scope.numberOfLocationsForSelectedJobs === 1 ? $filter('translate')('location') : $filter('translate')('locations');

            $scope.close = function () {
                $scope.$hide();
            };

            $scope.save = function () {

                $scope.loading = true;

                $scope.form.save()
                    .then(function (data) {
                        var removedAssignees = {
                            user_ids: _.pluck(data.removeAssignees.userIds, 'id'),
                            apply_to_notification_settings: data.removeAssignees.removedAssigneesNotificationSettings
                        };
                        var addedAssignees = {
                            user_ids: _.pluck(data.assignees.userIds, 'id'),
                            apply_to_notification_settings: data.assignees.addedAssigneesNotificationSettings
                        };

                        BrandAPI
                            .editJobsAssignees(
                                data.selectedJobsIds,
                                removedAssignees,
                                addedAssignees
                            )
                            .then(function (success) {
                                onSave();
                                $scope.loading = false;
                                $scope.close();
                                $scope.$digest();
                            }, function (err) {
                                $scope.loading = false;
                                console.error(err);
                            });
                    }, function (err) {
                        $scope.loading = false;
                        $scope.$digest();
                    });
            };


            $scope.form = new function () {
                var self = this;
                var formName = "manage-jobs-assignees-form";
                var _protected = BaseForm.call(self, formName, $scope);

                self.data = {
                    removeAssignees: {userIds: [], removedAssigneesNotificationSettings: false},
                    assignees: {userIds: [], addedAssigneesNotificationSettings: false},
                };

                self.load = function (mode, jobsIds, jobsAssignees, sharedAssignees) {
                    self.data.mode = mode;
                    self.data.selectedJobsIds = jobsIds;
                    self.data.jobsAssignees = jobsAssignees;
                    self.data.sharedAssignees = sharedAssignees;

                    for (var i = 0; i < self.data.sharedAssignees.length; i++) {
                        self.data.sharedAssignees[i].name =
                            self.data.sharedAssignees[i].first_name + " " + self.data.sharedAssignees[i].last_name;
                    }
                };

                self.save = function () {
                    var defer = $q.defer();

                    if (self.validator.validate()) {
                        defer.resolve(self.data);
                    } else {
                        defer.reject();
                    }

                    return defer.promise;
                };
            };

            BrandAPI
                .getBrandsAssignedJobsAdmins(selectedJobsIds)
                .then(function (jobsAssignees) {

                    var adminsForSelectedJobs = jobsAssignees;

                    adminsForSelectedJobs.forEach(function (assignee) {
                        assignee.name = assignee.first_name + " " + assignee.last_name;
                    });

                    $scope.form.load(
                        manageAssigneesMode,
                        selectedJobsIds,
                        adminsForSelectedJobs,
                        sharedAssignees
                    );

                    $scope.loadingData = false;
                    $scope.$digest();
                });
        }]);

})(angular);
